import { LanguageSelector as LanguageSelectorComponent } from "./language-selector";
import { flagIcons } from "./flag-icons";

export const LanguageSelector = Object.assign(LanguageSelectorComponent, {
  FlagIcons: flagIcons,
});
